module.exports = __webpack_public_path__ + "static/media/ForSalePoster.2f314d40.jpg";